__turbopack_context__.v({
  "contactInfo": "page-module__OSLHOG__contactInfo",
  "contactItem": "page-module__OSLHOG__contactItem",
  "content": "page-module__OSLHOG__content",
  "email": "page-module__OSLHOG__email",
  "errorMessage": "page-module__OSLHOG__errorMessage",
  "form": "page-module__OSLHOG__form",
  "formGroup": "page-module__OSLHOG__formGroup",
  "formSection": "page-module__OSLHOG__formSection",
  "hero": "page-module__OSLHOG__hero",
  "heroTitle": "page-module__OSLHOG__heroTitle",
  "infoSection": "page-module__OSLHOG__infoSection",
  "label": "page-module__OSLHOG__label",
  "page": "page-module__OSLHOG__page",
  "socialGroup": "page-module__OSLHOG__socialGroup",
  "socialLink": "page-module__OSLHOG__socialLink",
  "socialLinks": "page-module__OSLHOG__socialLinks",
  "socialSection": "page-module__OSLHOG__socialSection",
  "socialTitle": "page-module__OSLHOG__socialTitle",
  "submitButton": "page-module__OSLHOG__submitButton",
  "successMessage": "page-module__OSLHOG__successMessage",
});
